import { Box } from '@montugroup/design-system';
import { useMediaQuery, useTheme } from '@mui/material';
import { OnboardingFooterContainer } from '../Onboarding.styles';
import { OnboardingFooterDesktop } from './OnboardingFooterDesktop';
import { OnboardingFooterMobile } from './OnboardingFooterMobile';

export function OnboardingFooter() {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <OnboardingFooterContainer component="footer">
      <Box>{isMobileView ? <OnboardingFooterMobile /> : <OnboardingFooterDesktop />}</Box>
    </OnboardingFooterContainer>
  );
}
